module.exports = __webpack_public_path__ + "static/media/files.fbab844f.svg";